import * as React from 'react';
import { useContext, useMemo } from 'react';

import BaseComponents from './BaseComponents/theme';
import Inner from './Engine/theme';
import Button from './Button/theme';
import Input from './Input/theme';
import Counter from './Counter/theme';
import Link from './Link/theme';
import WarningModal from './WarningModal/theme';
import PromoLoader from './PromoLoader/theme';
import Toolbar from './Toolbar/theme';
import Money from './Money/theme';
import PhoneInput from './PhoneInput/theme';
import StatusMessage from './StatusMessage/theme';
import Slider from './Slider/theme';
import CloseIcon from './CloseIcon/theme';
import ServiceWithSegments from './ServiceWithSegments/theme';
import AccountModule from './Modules/Account/theme';
import Radio from './Radio/theme';
import Tabs from './Tabs/theme';
import SidebarItem from '@shared/SidebarItem/ui/theme';
import FlightsSortings from '@shared/FlightsSortings/ui/theme';
import CheckinCard from '@shared/CheckinCard/ui/theme';
import CheckinCardItem from '@shared/CheckinCard/ui/theme';

import PromoCode from './PromoCode/theme';
import Autocomplete from './Autocomplete/theme';
import FlightSelect from './FlightSelect/theme';
import PromoMessage from './PromoMessage/theme';
import Bag from './Baggage/Bag/theme';
import Passengers from './Passengers/theme';
import Refund from './Refund/theme';
import CheckoutOrderSummary from './CheckoutOrderSummary/theme';
import CustomerContactsForm from './CustomerContactsForm/theme';
import ResendTicketsForm from './ResendTicketsForm/theme';
import AdditionalServices from './AdditionalServices@deprecated/theme';
import VisaForm from './VisaForm/theme';
import IncludedOptions from './Baggage/IncludedOptions/theme';
import RecaptchaPage from './RecaptchaPage/theme';
import Segment from './BoardingPassDesk/theme';
import SegmentOld from './Segment/theme';
import Weather from './Weather/theme';
import MobileSelectedFare from './MobileSelectedFare/theme';
import SimpleLoader from './SimpleLoader/theme';
import SelectedPassenger from './SelectedPassenger/theme';
import SelectSegments from './SelectSegments/theme';
import ServiceRecommendation from './ServiceRecommendation/theme';
import Aeroexpress from './Aeroexpress/theme';
import Warnings from './Warnings/theme';
import Sidebar from './Sidebar/theme';
import MobileSidebar from './MobileSidebar/theme';
import SocialAuth from './SocialAuth/theme';
import MobileStepbar from './MobileStepbar/theme';
import PaymentForm from './PaymentForm/theme';
import PaymentTimeLimit from './PaymentTimeLimit/theme';
import MetasearchLoader from './MetasearchLoader/theme';
import Traveller from './Traveller/theme';
import OfferCard from './OfferCard/theme';
import CurrencyConverter from './CurrencyConverter/theme';
import Page404 from './Page404/theme';
import RetrieveBooking from './RetrieveBooking/theme';
import Amenities from './Amenities/theme';
import Datepicker from './Datepicker/theme';
import DateRangePicker from './DateRangePicker/theme';
import SearchFormDatepicker from './SearchFormDatepicker/theme';
import Lang from './Lang/theme';
import InfoCard from './InfoCard/theme';
import FullscreenDialog from './FullscreenDialog/theme';
import Modal from './Modal/theme';
import FlightPrice from './FlightPrice/theme';
import FareConditions from './FareConditions/theme';
import DocumentForm from './DocumentForm/theme';
import CompareFares from './CompareFares/theme';
import BaggageService from './BaggageService/theme';
import BaggagePage from './BaggagePage/theme';
import Airport from './Airport/theme';
import AdditionalServiceCard from './AdditionalServiceCard/theme';
import Meal from './Meal/theme';
import MealService from './MealService/theme';
import DesktopFlightInfo from './DesktopFlightInfo/theme';
import DesktopFlight from './DesktopFlight/theme';
import MobileFlight from './MobileFlight/theme';
import DesktopSummaryFlight from './DesktopSummaryFlight/theme';
import MobileSegmentInfo from './MobileSegmentInfo/theme';
import MobileSummaryFlight from './MobileSummaryFlight/theme';
import Contacts from './Contacts/theme';
import LoginPage from './LoginPage/theme';
import MobileAuthForm from './MobileAuthForm/theme';
import OrderSummary from './OrderSummary/theme';
import SeatMap from './SeatMap/theme';
import AdditionalServiceBanner from './AdditionalServiceBanner/theme';
import Stepbar from './BaseComponents/Stepbar/theme';
import WeekCalendar from './WeekCalendar/theme';
import Timer from './Timer/theme';
import Account from './Account/theme';
import { theme as SearchForm } from './SearchForm/theme';
import QuickSearchForm from './QuickSearchForm/theme';
import Results from './Results/theme';
import Checkout from './Checkout/theme';
import Disclaimer from './Disclaimer/theme';
import Service from './Service/theme';
import Checkin from './Modules/Checkin/theme';
import AddPassenger from './AddPassenger/theme';
import MobileSegment from './BoardingPassMob/theme';
import RegisteredPassenger from './RegisteredPassenger/theme';
import CheckoutAdditionalService from './CheckoutAdditionalService/theme';
import LoyaltyBonusStyles from './LoyaltyBonus/theme';
import Passenger from './Passenger/theme';
import SelectableSegment from './SelectableSegment/theme';
import Loyalty from './Loyalty/theme';
import Insurance from './Insurance/theme';
import Location from './Location/theme';
import FlightCard from './FlightCard/theme';
import FlightInfoCard from './FlightInfoCard/theme';
import TransferInfo from './TransferInfo/theme';
import FlightInfo from './FlightInfo/theme';
import DesktopFlightRoute from './DesktopFlightRoute/theme';
import FlightSortFilter from './FlightSortFilter/theme';
import OrderChangeHistoryModal from './OrderChangeHistoryModal/theme';
import PriceDetails from './LEO/Refund/PriceDetails/theme';
import TabButton from './Button/components/TabButton/theme';
import FareLock from './ConfirmOption/theme';
import OrderCard from './OrderCard/theme';
import Exchange from './Modules/Exchange/theme';
import VipServiceSelect from './VipServiceSelect/theme';
import TravellerForm from './TravellerForm/theme';
import MilesHistory from './MilesHistory/theme';
import MilesRecovery from './MilesRecovery/theme';
import PassengerForm from './PassengerForm/theme';
import Notification from './Notification/theme';
import FfpInfoNotice from './FfpInfoNotice/theme';
import PnrHistory from './PnrHistory/theme';
import AircraftPopup from './AircraftPopup/theme';
import AddBooking from './AddBooking/theme';
import ProfileControls from './ProfileControls/theme';
import Baggage from './Baggage/Baggage/theme';
import BaggageList from './Baggage/BaggageList/theme';
import IncludedBaggage from './Baggage/IncludedBaggage/theme';
import AdditionalBaggage from './Baggage/AdditionalBaggage/theme';
import BaggageTotalPriceBlock from './Baggage/BaggageTotalPriceBlock/theme';
import BaggageCounter from './Baggage/BaggageCounter/theme';
import UpgradeBaggageDialog from './Baggage/UpgradeBaggageDialog/theme';
import SpecialEquipment from './Baggage/SpecialEquipment/theme';
import BaggageCard from './Baggage/BaggageCard/theme';
import OverweightBaggage from './Baggage/OverweightBaggage/theme';
import BaggageDeleteButton from './Baggage/BaggageDeleteButton/theme';
import LocationAutocomplete from './LocationAutocomplete/theme';
import ScheduleForm from './ScheduleForm/theme';
import CoreSchedule from './Schedule/theme';
import ServiceAggregation from './ServicesAggregation/theme';
import EveryPortCard from './EveryPortCard/theme';

import PassengersDetails from './PassengersDetails/theme';
import AdditionalServiceWrapper from './AdditionalServiceWrapper/theme';
import InsurancePopup from './InsurancePopup/theme';
import SmsNotifications from './CheckoutAdditionalService/components/SmsNotifications/theme';
import PriorityBoardingPopup from './PriorityBoardingPopup/theme';
import { ClassesMap, DeepPartial } from './types';
import ActualizationOk from './Checkout/components/Checkout/Actualization/components/ActualizationOk/theme';
import Forms from './Forms/theme';
import CheckinStart from './CheckinStart/theme';
import CheckinConditions from './CheckinConditions/theme';
import MobileHeader from './MobileHeader/theme';
import SubsidySuggestPopup from './SubsidySuggestPopup/theme';
import SubsidyRejectPopup from './SubsidyRejectPopup/theme';
import UserCard from './UserCard/theme';
import TravelCompanions from './TravelCompanions/theme';
import SlideBottom from './SlideBottom/theme';
import Subscriptions from './Modules/Subscriptions/theme';
import SubscriptionsLanding from './Modules/Subscriptions/components/Landing/theme';
import TransitTooltip from './TransitTooltip/theme';
import ServiceSummary from './ServiceSummary/theme';
import Cart from './Cart/theme';
import TicketExample from './TicketExample/theme';
import LoyaltyInfo from './LoyaltyInfo/theme';
import SureModal from './SureModal/theme';
import InfoMessages from './InfoMessages/theme';
import WxPagination from './WxPagination/theme';
import Subsidies from './Subsidies/theme';
import SecureAccess from './SecureAccess/theme';
import html from './html/theme';
import ResultsError from './ResultsError/theme';
import FlightStatus from './Modules/FlightStatus/theme';
import NasRefundServices from './NasRefundServices/NasRefundServices.css';
import Communications from './Communications/theme';
import PaymentMethodsError from './PaymentMethodsError/theme';
import InsurancePage from './InsurancePage/theme';
import ModalConfirm from './ModalConfirm/theme';
import ModalFullscreen from './ModalFullscreen/theme';
import EditPassenger from './EditPassenger/theme';
import TicketRequest from './TicketRequest/theme';
import Consents from './Consents/theme';
import Transfer from './Transfer/theme';
import RefundSummary from './RefundSummary/theme';
import UpgradeFlightClass from './UpgradeFlightClass/theme';
import AIPurchasePredictionService from './AIPurchasePredictionService/theme';
import AgreementCheckboxWrapper from './AgreementCheckboxWrapper/theme';
import AircraftLivery from './AircraftLivery/theme';
import BookingPreview from './BookingPreview/theme';
import Navigation from '@widgets/navigation/theme';
import PlaneSpinner from './PlaneSpinner/theme';
import CardExtra from './CardExtra/theme';
import InsuranceModalConfirmINN from './InsuranceModalConfirmINN/theme';
import SlickSlider from './SlickSlider/theme';
import TicketRefundOptionModal from './TicketRefundOptionModal/theme';
import ImageZoom from './ImageZoom/theme';

// FSD
import Entities from './__fsd__/entities/theme';
import Widgets from './__fsd__/widgets/theme';
import Shared from './__fsd__/shared/ui/theme';
import Features from './__fsd__/features/theme';

import { mergeClasses, mergeCSS } from './utils';

const theme = {
	// Elements
	Link,
	Button,
	Counter,
	Input,
	Slider,
	Money,
	WarningModal,
	PromoLoader,
	Toolbar,
	Radio,
	WxPagination,
	Tabs,
	ModalConfirm,
	ModalFullscreen,
	SlickSlider,
	SidebarItem,
	ImageZoom,
	FlightsSortings,
	PriceDetails,
	CheckinCard,
	CheckinCardItem,

	// Widgets
	UpgradeFlightClass,
	LocationAutocomplete,
	ServiceWithSegments,
	TabButton,
	CloseIcon,
	TransferInfo,
	FlightInfo,
	FlightInfoCard,
	FlightCard,
	Location,
	SelectableSegment,
	RecaptchaPage,
	Bag,
	AdditionalServices,
	ResendTicketsForm,
	IncludedOptions,
	PaymentMethodsError,
	MobileAuthForm,
	Segment,
	Weather,
	StatusMessage,
	SimpleLoader,
	ServiceRecommendation,
	AddPassenger,
	MobileSegment,
	MobileSelectedFare,
	Aeroexpress,
	RegisteredPassenger,
	SelectedPassenger,
	SelectSegments,
	Warnings,
	AdditionalServiceBanner,
	Sidebar,
	MobileSidebar,
	MobileStepbar,
	PaymentForm,
	PaymentTimeLimit,
	Stepbar,
	SocialAuth,
	WeekCalendar,
	MetasearchLoader,
	VisaForm,
	OfferCard,
	Timer,
	Traveller,
	OrderSummary,
	PhoneInput,
	CurrencyConverter,
	Page404,
	RetrieveBooking,
	Amenities,
	Datepicker,
	SearchFormDatepicker,
	DateRangePicker,
	Lang,
	InfoCard,
	FullscreenDialog,
	FlightPrice,
	LoginPage,
	FareConditions,
	DocumentForm,
	CompareFares,
	BaggageService,
	BaggagePage,
	Airport,
	AircraftPopup,
	AdditionalServiceCard,
	Meal,
	MealService,
	DesktopFlightInfo,
	DesktopFlight,
	MobileFlight,
	DesktopSummaryFlight,
	MobileSummaryFlight,
	Contacts,
	Results,
	SearchForm,
	QuickSearchForm,
	SeatMap,
	Account,
	Checkout,
	MobileSegmentInfo,
	Modal,
	Disclaimer,
	Service,
	Passenger,
	Checkin,
	CheckoutAdditionalService,
	LoyaltyBonusStyles,
	CheckoutOrderSummary,
	Loyalty,
	Passengers,
	Autocomplete,
	Insurance,
	DesktopFlightRoute,
	PromoMessage,
	FlightSortFilter,
	PromoCode,
	CustomerContactsForm,
	OrderCard,
	FlightSelect,
	OrderChangeHistoryModal,
	Inner,
	FareLock,
	VipServiceSelect,
	MilesRecovery,
	MilesHistory,
	ActualizationOk,
	Exchange,
	Refund,
	Notification,
	PassengerForm,
	FfpInfoNotice,
	PnrHistory,
	AddBooking,
	ProfileControls,
	AccountModule,
	TravellerForm,
	Forms,
	Baggage,
	BaggageList,
	BaggageTotalPriceBlock,
	BaggageCounter,
	IncludedBaggage,
	AdditionalBaggage,
	UpgradeBaggageDialog,
	SpecialEquipment,
	BaggageCard,
	OverweightBaggage,
	BaggageDeleteButton,
	AdditionalServiceWrapper,
	CheckinStart,
	CheckinConditions,
	MobileHeader,
	ScheduleForm,
	CoreSchedule,
	SubsidySuggestPopup,
	SubsidyRejectPopup,
	ServiceAggregation,
	EveryPortCard,
	UserCard,
	TravelCompanions,
	PassengersDetails,
	SlideBottom,
	Subscriptions,
	SubscriptionsLanding,
	BaseComponents,
	InsurancePopup,
	SmsNotifications,
	PriorityBoardingPopup,
	TransitTooltip,
	ServiceSummary,
	Cart,
	TicketExample,
	LoyaltyInfo,
	SureModal,
	Subsidies,
	InfoMessages,
	SecureAccess,
	html,
	ResultsError,
	FlightStatus,
	Communications,
	InsurancePage,
	EditPassenger,
	TicketRequest,
	Consents,
	Transfer,
	RefundSummary,
	AIPurchasePredictionService,
	AgreementCheckboxWrapper,
	AircraftLivery,
	BookingPreview,
	NasRefundServices,
	Navigation,
	CardExtra,
	InsuranceModalConfirmINN,
	TicketRefundOptionModal,
	PlaneSpinner,
	SegmentOld,

	// FSD
	Widgets,
	Entities,
	Shared,
	Features
};

export type EngineTheme = DeepPartial<typeof theme>;

const ThemeContext = React.createContext<EngineTheme>(theme);

interface ThemeProviderProps {
	value: EngineTheme;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = React.memo(({ value, children }) => {
	const theme: EngineTheme = useContext(ThemeContext);

	return <ThemeContext.Provider value={mergeCSS(theme, value)}>{children}</ThemeContext.Provider>;
});

export const { Consumer: ThemeConsumer } = ThemeContext;
export { ThemeContext };

export const useTheme = <M extends keyof EngineTheme>(module: M): EngineTheme[M] => useContext(ThemeContext)[module];

export const useMergeClasses = <A extends ClassesMap, B extends ClassesMap>(
	base?: Partial<A> | null,
	override?: Partial<B> | null
): A & B => {
	return useMemo(() => mergeClasses<A, B>(base, override), [base, override]);
};
